export class MultiSelectWithAutoTransform extends kendo.ui.MultiSelect {
    constructor(element, options) {
        super(element, MultiSelectWithAutoTransform.getOptions(options));
        this.isUpdating = false;
        this.countUntilTransform = 3;
        this.itemChangeClientSide = () => {
            if (!this.isUpdating) {
                if (this.value().length > this.countUntilTransform) {
                    this.convertToSingleItem();
                }
                else {
                    this.convertToTagList();
                    if (!$(".isReadOnly").length) {
                        const controlGroupWidth = this.wrapper.find(".k-multiselect-wrap").width() - 50;
                        this.wrapper.find("li").each((index, element) => {
                            const item = $(element);
                            if (item.outerWidth() >= controlGroupWidth) {
                                item.find(".dropDownAvatarBackgroundText").addClass("limitWidth");
                            }
                        });
                    }
                }
            }
        };
        this.convertToSingleItem = () => {
            if (this.options.tagMode !== "single") {
                this.isUpdating = true;
                const values = this.value();
                this.options.tagMode = "single";
                this.options.clearButton = false;
                this._tagTemplate(); //eslint-disable-line
                const total = this.dataSource.total();
                const tagList = this.tagList;
                if (!this._maxTotal || this._maxTotal < total) { //eslint-disable-line
                    this._maxTotal = total; //eslint-disable-line
                }
                tagList.html("");
                if (values.length) {
                    tagList.append(this.tagTemplate({
                        values,
                        dataItems: this.dataItems(),
                        maxTotal: this._maxTotal,
                        currentTotal: total
                    }));
                }
                this.isUpdating = false;
            }
        };
        this.convertToTagList = () => {
            if (this.options.tagMode !== "multiple") {
                this.isUpdating = true;
                const tagList = this.tagList;
                this.options.tagMode = "multiple";
                this.options.clearButton = true;
                this._tagTemplate(); //eslint-disable-line
                tagList.html("");
                this.dataItems().forEach((item) => {
                    tagList.append(this.tagTemplate(item)); //eslint-disable-line
                });
                this.isUpdating = false;
            }
        };
        this.selectItems = (value) => {
            const oldArray = [];
            for (let i = 0; i < value.length; i++) {
                const dataItem = this.dataSource.get(value[i]);
                if (!dataItem) {
                    oldArray.push(value[i]);
                }
            }
            this.value(oldArray);
            let def = $.Deferred().resolve().promise();
            for (let i = 0; i < value.length; i++) {
                const dataItem = this.dataSource.get(value[i]);
                if (dataItem) {
                    def = def.then((this).listView.select(this.list.find(`[data-uid='${dataItem.uid}']`))).then((this).listView._selectedDataItems.push(dataItem)); //eslint-disable-line
                }
            }
        };
        this.bind("change", this.itemChangeClientSide);
        this.bind("dataBound", this.itemChangeClientSide);
        this.countUntilTransform = options.countUntilTransform;
        $(document).ready(() => {
            $(".k-multiselect").kendoTooltip({
                filter: ".multiSelectTooltip",
                content: ((e) => $(e.target).data("tooltip"))
            });
        });
    }
    static mapParameterWithTransform(a) {
        const element = a.data("kendoMultiSelectWithAutoTransform").input.val();
        return { text: element };
    }
}
MultiSelectWithAutoTransform.getOptions = (options) => {
    const dataTextField = options.dataTextField !== undefined ? options.dataTextField : "data";
    const multipleTemplate = options.tagTemplate !== undefined
        ? options.tagTemplate
        : `#=${dataTextField}#`;
    const template = `#if(data.values){#<span class="multiSelectTooltip" data-tooltip="#= MultiSelectWithAutoTransform.createToolTip(data.dataItems,"${dataTextField}") #">#= data.values.length # Einträge ausgewählt </span>#}else{#${multipleTemplate}#}#`; //eslint-disable-line
    options.tagTemplate = template;
    return options;
};
MultiSelectWithAutoTransform.createToolTip = (values, options) => {
    let tooltip = "";
    for (let i = 0; i < values.length; i++) {
        if (typeof values[i] === 'object') {
            if (options !== "data") {
                tooltip += `${values[i][options]}, `;
            }
        }
        else {
            tooltip += `${values[i]}, `;
        }
    }
    if (tooltip.length > 2) {
        return tooltip.substring(0, tooltip.length - 2);
    }
    return tooltip;
};
// Create an alias of the prototype (required by kendo.ui.plugin)
MultiSelectWithAutoTransform.fn = MultiSelectWithAutoTransform.prototype;
// Deep clone the widget default options
MultiSelectWithAutoTransform.fn.options = $.extend(true, {}, kendo.ui.MultiSelect.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
MultiSelectWithAutoTransform.fn.options.name = "MultiSelectWithAutoTransform";
// Create a jQuery plugin.
kendo.ui.plugin(MultiSelectWithAutoTransform);
